import React, { Component } from 'react';
import { View } from '../UIElements/All.js';
import { Colors } from '../Managers/ThemeManager';
import { isRetail } from '../Managers/Utils';
import Loc from './Localization'

export default class Card extends Component 
{
  constructor(props) 
  {
    super(props);
    var state = {};
    this.state = state;
  }

  setIsUpdating(isUpdating)
  {
    this.setState({isUpdating});
  }

  getModal()
  {
    return this._modal;
  }

  render() 
  {
  	var self = this;
    var style = typeof this.props.style === 'undefined' ? {} : this.props.style;
    style.backgroundColor = Colors.background2;
    style.borderColor = Colors.border1;
    style.borderWidth = 1;
    style.borderStyle = "solid";
    style.borderRadius = 8;
    style.flexDirection = 'column';

    return (
      <View style={style}>
        {
          isRetail() && typeof this.props.title !== 'undefined' ?
            <View style={{padding:8, borderTopRightRadius:8, borderBottomStyle:'solid', borderBottomWidth:1, borderBottomColor:Colors.border1, borderTopLeftRadius:8, marginRight:-.5, flex:-1, backgroundColor:Colors.background4, color:Colors.text1, alignSelf:'stretch'}}>
              <Loc locKey={this.props.title}></Loc>
            </View>
          : null
        }
        <View style={{flex:1, alignSelf:'stretch', flexDirection:'column', borderRadius:10}}>
          {this.props.children}
        </View>
      </View>
    );
  }
}

